import React from "react";
import { NormalizedNutritionV2, PreferenceItemV2 } from "../type";
import TileGrid from "./TileGrid";
import { ReadOnlyFieldConfig } from "../ReadOnlyField";

type Props = {
  data: NormalizedNutritionV2;
  openPopperId: string | null;
  setOpenPopperId: React.Dispatch<React.SetStateAction<string | null>>;
};

const preferenceSummary = (items: PreferenceItemV2[]) => {
  if (items.length === 0) return "—";
  const preferred = items.filter((item) => item.preferred).length;
  return `${preferred} preferred, ${items.length - preferred} excluded`;
};

const FoodPreferencesTab = ({ data, openPopperId, setOpenPopperId }: Props) => {
  const { foodPreferences } = data;

  // Row-major, so the four tiles read left→right and Recipe preferences wraps
  // to row 2. Was three independent column stacks, which put Recipe
  // preferences under Dietary restrictions instead.
  const tiles: ReadOnlyFieldConfig[] = [
    {
      label: "Dietary restrictions",
      value:
        foodPreferences.dietaryRestrictions.length > 0
          ? foodPreferences.dietaryRestrictions.join(", ")
          : "No allergies",
      fieldKey: "dietary-restrictions",
      items: foodPreferences.dietaryRestrictions.map((name) => ({ name })),
    },
    {
      label: "Food preferences",
      value: foodPreferences.foodPreferences.summary,
      fieldKey: "food-preferences",
      groups: foodPreferences.foodPreferences.groups,
    },
    {
      label: "Key ingredients",
      value:
        foodPreferences.keyIngredients.length > 0
          ? foodPreferences.keyIngredients.join(", ")
          : "—",
      fieldKey: "key-ingredients",
      items: foodPreferences.keyIngredients.map((name) => ({
        name,
        preferred: true,
      })),
    },
    {
      label: "Recipe preferences",
      value: preferenceSummary(foodPreferences.recipePreferences),
      fieldKey: "recipe-preferences",
      items: foodPreferences.recipePreferences,
    },
  ];

  return (
    <TileGrid
      tiles={tiles}
      openPopperId={openPopperId}
      setOpenPopperId={setOpenPopperId}
    />
  );
};

export default FoodPreferencesTab;
